/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setupprofilesubtitle2Inputs */

const en_setupprofilesubtitle2 = /** @type {(inputs: Setupprofilesubtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every profile has its own dashboard. Set it up now and you land right in it.`)
};

const de_setupprofilesubtitle2 = /** @type {(inputs: Setupprofilesubtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jedes Profil hat sein eigenes Dashboard. Du richtest es jetzt ein und bist danach direkt darin.`)
};

/**
* | output |
* | --- |
* | "Every profile has its own dashboard. Set it up now and you land right in it." |
*
* @param {Setupprofilesubtitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const setupprofilesubtitle2 = /** @type {((inputs?: Setupprofilesubtitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setupprofilesubtitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_setupprofilesubtitle2(inputs)
	return de_setupprofilesubtitle2(inputs)
});
export { setupprofilesubtitle2 as "setupProfileSubtitle" }